export default "__VITE_ASSET__QUK_$OTN__"